import { Box, Button, Card, Center, Container, PasswordInput, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../components/ErrorMessage';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';
import useFetch from '../helpers/useFetch';
import mainLogo from '../logo.png';

const ResetPasswordConfirmPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const defaultFormData = {
    password: '',
    passwordConfirmation: '',
  };
  const [formData, setFormData] = useState(defaultFormData);
  const [error, setError] = useState();
  const { resetPasswordToken } = useParams();

  const submitForm = (e) => {
    setError(undefined);
    e.preventDefault();
    fetch(`/api/admin/users/resetPassword`, {
      method: 'POST',
      body: JSON.stringify({ resetPasswordToken, password: formData.password }),
    })
      .then(() => {
        navigate('/');
      })
      .catch(setError);
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({ ...prevFormData, [e.target.name]: e.target.value }));
  };

  return (
    <div>
      <Metadata title={`${Page['resetPasswordConfirm']}`} />
      <Center pt={60} h="100%">
        <Container size="xs" w="100%">
          <Card withBorder p="lg">
            <Box ta="center" mb="lg">
              <img src={mainLogo} alt="Releva" style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>

            <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
              <Text ta="center" mt="md" mb="md">
                Please choose a new password.
              </Text>
              <PasswordInput
                size="lg"
                name="password"
                label="Password"
                placeholder="Your Password"
                value={formData.password}
                error={formData !== defaultFormData && formData.password === '' ? 'password cannot be blank' : null}
                onChange={handleChange}
                mb="md"
              />

              <PasswordInput
                size="lg"
                name="passwordConfirmation"
                label="Confirm password"
                placeholder="Your Password"
                value={formData.passwordConfirmation}
                error={formData.password !== formData.passwordConfirmation ? 'passwords do not match' : null}
                onChange={handleChange}
                mb="md"
              />

              <ErrorMessage message={error} />

              <Button
                size="lg"
                fullWidth
                type="submit"
                disabled={!formData.password || formData.password !== formData.passwordConfirmation}
              >
                <IconCheck /> Set new password
              </Button>
            </Box>
          </Card>
        </Container>
      </Center>
    </div>
  );
};

export default ResetPasswordConfirmPage;
